import isMinimalView from './isMinimalView';

/**
 * Given a render type, returns an object describing properties about the view,
 * including whether the view is embedded or exporting, and whether minimal
 * view options should be applied.
 * @param {string} renderType - The render type to examine.
 * @returns {object} - An object containing properties about the view.
 */
export default function getViewProperties(renderType) {
  const isEmbedded = 'embed' === renderType;
  const isExporting = 'image-export' === renderType;
  return {
    isEmbedded,
    isExporting,
    isMinimalView: isMinimalView({ isEmbedded, isExporting }),
  };
}



// WEBPACK FOOTER //
// ./app/services/getViewProperties.js